<button
  mat-button
  class="transparent-button gift-button"
  (click)="openBottomSheet()"
>
  <img src="/assets/images/icons/gift.svg" alt="" />
  <span>Buy As Gift</span>
</button>
